import { Card, CardBody, Tab, Tabs } from "@heroui/react";
import LoginForm from "./login-form";
import RegisterForm from "./register-form";
import { useTranslations } from "../../../../i18n";

function Auth({ selectedTab }: { selectedTab?: string }) {
  const t = useTranslations("auth");

  const tabs = [
    {
      id: "login",
      label: t("login"),
      content: <LoginForm />,
    },
    {
      id: "register",
      label: t("register"),
      content: <RegisterForm />,
    },
  ];

  return (
    <Card className="w-full max-w-md mx-auto mt-10">
      <CardBody>
        <Tabs
          variant="underlined"
          size="lg"
          aria-label="Dynamic tabs"
          items={tabs}
          defaultSelectedKey={selectedTab}
        >
          {(item) => (
            <Tab key={item.id} title={item.label}>
              {item.content}
            </Tab>
          )}
        </Tabs>
      </CardBody>
    </Card>
  );
}

export default Auth;
